import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  tasks: [],
  tasksRef: null,
  tasksLoaded: false
}

const getters = {
  tasks (state) {
    return state.tasks
  },
  tasksRef (state) {
    return state.tasksRef
  },
  tasksLoaded (state) {
    return state.tasksLoaded
  },
  taskByKey (state) {
    return (taskKey) => {
      return state.tasks.find(t => {
        return t.key === taskKey
      })
    }
  },
  taskBySection (state) {
    return (sectionKey) => {
      let tasks = []
      for (let t of state.tasks) {
        if (t.sectionKey === sectionKey) tasks.push({...t})
      }
      return tasks
    }
  },
  taskByUrlBySection (state) {
    return (taskUrl, sectionKey) => {
      return state.tasks.find(t => {
        return (t.url === taskUrl) && (t.sectionKey === sectionKey)
      })
    }
  }
}

const mutations = {
  setTasks (state, payload) {
    state.tasks = payload
  },
  setTasksRef (state, payload) {
    state.tasksRef = payload
  },
  setTasksLoaded (state, payload) {
    state.tasksLoaded = payload
  }
}

const actions = {
  loadTasks: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('tasks')
    ref.on('value', snapshot => {
      const tasks = []
      snapshot.forEach(t => {
        tasks.push({key: t.key, ...t.val()})
      })
      store.commit('setTasksRef', ref)
      store.commit('setTasks', tasks)
      store.commit('setTasksLoaded', true)
      resolve()
    })
  }),
  createTask: (store, payload) => new Promise((resolve, reject) => {
    const newTask = {...payload}
    store.getters.tasksRef.push(newTask).then(t => {
      resolve(t)
    }).catch(err => {
      reject(err)
    })
  }),
  updateTask: (store, payload) => new Promise((resolve, reject) => {
    const newTask = {...payload}
    store.getters.tasksRef.child(newTask.key).set(newTask).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  deleteTask: (store, payload) => new Promise((resolve, reject) => {
    const toDelete = {...payload}
    for (let t of store.getters.tasks) {
      if (t.type === 'Linking') {
        if (t.linkedTaskKey === toDelete.key) {
          reject(new Error('Delete failed, task is currently linked to another task'))
          return
        }
      }
    }
    if (toDelete.type === 'Lecture') {
      store.dispatch('deleteVideo', toDelete).then(() => {
        store.getters.tasksRef.child(toDelete.key).remove().then(() => {
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    } else {
      store.getters.tasksRef.child(toDelete.key).remove().then(() => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    }
  }),
  deleteVideo: (store, payload) => new Promise((resolve, reject) => {
    const task = {...payload}
    if (task.fileName) {
      if (task.fileName === '') resolve()
      else {
        const videoRef = firebase.storage().ref().child('lectures').child(task.key)
        videoRef.child(task.fileName).delete().then(() => {
          resolve()
        }).catch(err => {
          reject(err)
        })
      }
    } else resolve()
  }),
  resetTasks: (store) => new Promise((resolve, reject) => {
    if (store.getters.tasksRef) store.getters.tasksRef.off()
    store.commit('setTasks', [])
    store.commit('setTasksRef', null)
    store.commit('setTasksLoaded', false)
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/content/tasks.js